import script from "./CustomPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__